/* src/app/views/template/components/templates/digital/digital-product-templates/digital-product-template-list/digital-product-template-list.component.scss */
/*# sourceMappingURL=digital-product-template-list.component.css.map */
